import { reactive } from 'vue';

export function useNotification() {
  const self = {
    notification: reactive({ text: '', type: 'success' }),
  };

  self.notify = (text, type = 'success') => {
    self.notification.text = '';
    self.notification.type = type;
    setTimeout(() => { self.notification.text = text; self.notification.type = type; }, 50);
  };

  return self;
}
